import React, { useMemo, createRef, useEffect } from 'react';
import { modalConsControl } from "../../wrappers/modalConsControl";
import moment from "moment"
import FullCalendar from '@fullcalendar/react'
import interactionPlugin from "@fullcalendar/interaction";
import timelinePlugin from '@fullcalendar/timeline'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import momentPlugin from '@fullcalendar/moment';
import ModalPreviewBooking from "./ModalPreviewBooking";

import "./fullCalendar.css"
import { changeBookingRental } from "../../../api/apiRequests";
import ModalNewBooking from "./ModalNewBooking";
import useRentals from "../../../hooks/useRentals";
import Loading from "../../shared/wait/Loading";

const BookingCalendar = ({ changeModal }) => {
  const calendarRef = createRef()
  // const [shownPeriod, setShownPeriod] = useState()
  // const [from, to] = shownPeriod || []

  const {
    rentals,
    refreshRentals,
    isLoading: isLoadingRentals
  } = useRentals({
    populateBookings: true,
    // autoload: !!shownPeriod,
    // from: !!from && moment(from).subtract(2, 'month').toISOString(),
    // to: !!to && moment(to).add(2, 'month').toISOString()
  })

  // Each 10 minutes requests will be updated
  useEffect(() => {
    const interval = setInterval(refreshRentals, 100000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [])


  const getColor = (booking, rental) => {
    if (booking.leaveIt.delivery || booking.pickUp.delivery) {
      return "#faff5e"
    } else if (booking.status === "doubtful") {
      return "#e57fcf"
    } else {
      return rental.model.color
    }
  };

  const createObjectFromBooking = (rental, booking) => {
    return {
      id: booking._id,
      resourceId: rental.licensePlate,
      model: rental.model._id,
      title: booking.user.name,
      start: moment(booking.pickUp.date).toArray(),
      end: moment(booking.leaveIt.date).toArray(),
      color: getColor(booking, rental),
      extendedProps: {
        leaveIt: booking.leaveIt,
        pickUp: booking.pickUp,
        user: booking.user,
        booking: booking,
        rental: rental,
        payMethod: booking.payMethod,
        tooltip: `${booking.user.name} ${booking.user.surname} (${booking.user.email})`,
      }
    }
  };

  const [events, resources] = useMemo(() => {
    const newEvents = [];
    const newResources = [];
    (rentals || []).forEach(rental => {
      if (rental.model.active) {
        if (rental.bookings.length > 0) {
          const bookings = rental.bookings;
          bookings.forEach(booking => {
            if (booking.active && booking.status !== "canceled") {
              newEvents.push(createObjectFromBooking(rental, booking));
            }
          });
        }
        newResources.push({
          id: rental.licensePlate,
          title: ((rental.paused) ? "⊗ " : "") + rental.licensePlate,
          extendedProps: {
            _id: rental._id,
            model: rental.model.name + " " + rental.model.cubicCapacity,
            paused: rental.paused,
          }
        })
      }
    });
    return [newEvents, newResources]
    // eslint-disable-next-line
  }, [rentals])

  const clickEvent = ({ event }) => changeModal(
    <ModalPreviewBooking changeModal={changeModal} info={event._def.extendedProps} refreshRentals={refreshRentals}/>)
  
  const clickDay = (infoDay) => changeModal(
    <ModalNewBooking scooter={infoDay.resource.id} changeModal={changeModal} initDay={infoDay.startStr} endDay={infoDay.endStr} afterCreate={refreshRentals}
                     rentals={rentals} isLoadingRentals={isLoadingRentals}
    />)

  const handleResourceDrop = async ({ event, oldResource, newResource }) => {
    if (newResource.extendedProps.paused || newResource.extendedProps.model !== oldResource.extendedProps.model)
      event.setResources([oldResource])
    else {
      await changeBookingRental(event.id, oldResource.extendedProps._id, newResource.extendedProps._id)
        .then(() => alert("Se ha actualizado la reserva"))
        .catch(() => {
          event.setResources([oldResource])
          alert("No se ha podido actualizar la reserva")
        })
      await refreshRentals()
    }
  }


  return <>
    {!rentals && <Loading text="Cargando reservas..."/>}
    <div className={"container-fluid min-vh-100 py-4 " + (!rentals ? "d-none" : "")}>
      <FullCalendar
        ref={calendarRef}
        plugins={[timelinePlugin, resourceTimelinePlugin, interactionPlugin, momentPlugin]}
        header={{
          left: '',
          center: 'title',
          right: 'today,prev,next'
        }}
        footer={{
          left: 'resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth',
          center: '',
          right: ''
        }}
        buttonText={{
          today: 'Hoy',
          month: 'Mes',
          week: 'Semana',
          day: 'Día',
          list: 'Lista'
        }}
        resourceGroupField="model"
        defaultView="resourceTimelineMonth"
        // droppable={false}
        // disableDragging={true}
        // disableResizing={true}
        // editable={false}
        eventDropStart={(event) => event.editable = false}
        resources={resources}
        id="BookinCalendar"
        weekends={true}

        allDay={true}
        defaultDate={new Date()}
        displayEventTime={true}
        slotDuration="24:00:00"
        displayEventEnd={true}
        handleWindowResize={true}
        navLinks={true}
        resourceAreaWidth="150px"
        resourceLabelText="Vespas"
        nowIndicator={true}
        progressiveEventRendering={false}
        schedulerLicenseKey={'GPL-My-Project-Is-Open-Source'}
        events={events}
        eventTimeFormat={{
          hour: 'numeric',
          minute: '2-digit',
          meridiem: false
        }}
        slotLabelFormat={[
          { month: 'long', year: 'numeric' }, // top level of text
          { day: '2-digit', weekday: 'short' } // lower level of text
        ]}
        eventColor="#a2c5d3"
        eventTextColor="#404040"
        eventBorderColor="#1c355e"
        height="auto"
        timeZone="Europe/Madrid"
        eventClick={clickEvent}
        locale="es"
        selectable={true}
        select={clickDay}

        editable={false}
        eventResourceEditable
        eventDrop={handleResourceDrop}
        eventOverlap={false}


        eventRender={({ el, event }) => {
          el.title = event.extendedProps.tooltip
        }}
        // eventStartEditable
        // eventResizableFromStart
        // eventDurationEditable
        // eventOverlap={false}
        // eventResizeInfo={console.log}


        // datesRender={calendar => {
        //   const start = moment(calendar.view.activeStart).toISOString()
        //   const end = moment(calendar.view.activeEnd).toISOString()
        //   if(start !== from && end !== to)
        //     setShownPeriod([start, end])
        // }}
      />
    </div>
  </>
}

export default modalConsControl(BookingCalendar);
